import { render, staticRenderFns } from "./BoardDetailDefaultLayout.vue?vue&type=template&id=847cea94&scoped=true&"
import script from "./BoardDetailDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardDetailDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847cea94",
  null
  
)

export default component.exports